<template>
<div class="carousel slide" data-rided="carousel">
  <!-- Indicators -->
  <ol class="carousel-indicators" v-show="indicators && slider.length > 1">
    <indicator :indicator.sync="indicator" :active-index.sync="activeIndex" :is-animating.sync="isAnimating"></indicator>
  </ol>
  <!-- Wrapper for slides -->
  <div class="carousel-inner" role="listbox">
    <slot></slot>
  </div>
  <!-- Controls -->
  <div v-show="controls && slider.length > 1 ">
    <a class="left carousel-control" @click="prevClick" role="button" data-slide="prev">
      <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="right carousel-control" @click="nextClick" role="button" data-slide="next">
      <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</div>
</template>

<script>
  const EventListener = {
    /**
     * Listen to DOM events during the bubble phase.
     *
     * @param {DOMEventTarget} target DOM element to register listener on.
     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
     * @param {function} callback Callback function.
     * @return {object} Object with a `remove` method.
     */
    listen (target, eventType, callback) {
      if (target.addEventListener) {
        target.addEventListener(eventType, callback, false)
        return {
          remove () {
            target.removeEventListener(eventType, callback, false)
          }
        }
      } else if (target.attachEvent) {
        target.attachEvent('on' + eventType, callback)
        return {
          remove () {
            target.detachEvent('on' + eventType, callback)
          }
        }
      }
    }
  }

  export default {
    props: {
      indicators: {
        type: Boolean,
        default: true
      },
      controls: {
        type: Boolean,
        default: true
      },
      interval: {
        type: Number,
        default: 5000
      }
    },
    components: {
      'indicator': {
        props: ['indicator', 'activeIndex', 'isAnimating'],
        template: '<li v-for="i in indicator" track-by="$index" @click="handleIndicatorClick($index)" v-bind:class="{\'active\':$index === activeIndex}"><span></span></li>',
        methods: {
          handleIndicatorClick (index) {
            if (this.isAnimating) return false
            this.isAnimating = true
            this.activeIndex = index
          }
        }
      }
    },
    data () {
      return {
        indicator: [],
        activeIndex: 0,
        isAnimating: false
      }
    },
    computed: {
      slider () {
        console.log(this.$children.length)
        return this.$el.querySelectorAll('.item')
      }
    },
    watch: {
      '$children' (val) {
        console.log(val)
      }
    },
    methods: {
      slide (direction, selected, prev) {
        if (selected === 0 && selected === prev) {
          return
        }
        if (this._prevSelectedEvent) this._prevSelectedEvent.remove()
        if (this._selectedEvent) this._selectedEvent.remove()
        const prevSelectedEl = this.slider[prev]
        const selectedEl = this.slider[selected]
        const transitionendFn = () => {
          [...this.slider].forEach((el) => {
            el.className = 'item'
          })
          selectedEl.classList.add('active')
          this.isAnimating = false
        }
        direction === 'left' ? selectedEl.classList.add('next') : selectedEl.classList.add('prev')
        // request property that requires layout to force a layout

        selectedEl.clientHeight
        this._prevSelectedEvent = EventListener.listen(prevSelectedEl, 'transitionend', transitionendFn)
        this._selectedEvent = EventListener.listen(selectedEl, 'transitionend', transitionendFn)
        prevSelectedEl.classList.add(direction)
        selectedEl.classList.add(direction)
      },
      nextClick () {
        if (this.isAnimating) return false
        this.isAnimating = true

        let next = this.activeIndex + 1 < this.slider.length ? this.activeIndex + 1 : 0
        this.slide('left', next, this.activeIndex)
        this.activeIndex = next
      },
      prevClick () {
        if (this.isAnimating) return false
        this.isAnimating = true
        let next = this.activeIndex === 0 ? this.slider.length - 1 : this.activeIndex - 1
        this.slide('right', next, this.activeIndex)
        this.activeIndex = next
      }
    },
    ready () {
      let intervalID = null
      const el = this.$el
      function intervalManager (flag, func, time) {
        flag ? intervalID = setInterval(func, time) : clearInterval(intervalID)
      }
      if (this.interval) {
        intervalManager(true, this.nextClick, this.interval)
        el.addEventListener('mouseenter', () => intervalManager(false))
        el.addEventListener('mouseleave', () => intervalManager(true, this.nextClick, this.interval))
      }
    }
  }
</script>

<style scoped>
  .carousel-control {
    cursor: pointer;
  }
</style>



/** WEBPACK FOOTER **
 ** Carousel.vue?ad8e203a
 **/